import angular from 'angular';
import {webModulMedNg2støtte} from "./webModul";
import {ng2ModulSomNedgradert} from "web-ng2/bootstrap-ng2";

const hovedmodul = webModulMedNg2støtte(ng2ModulSomNedgradert());

const rootElement = angular.element(document.body);
// Ensure AngularJS destroys itself on hot reloads. @todo trengs dette?
const eksisterendeInjektor = rootElement.injector();
if (eksisterendeInjektor) {
    eksisterendeInjektor.get('$rootScope').$destroy();
    rootElement.data('$injector', null);
    throw new Error("#### eksisterendeInjektor FINNES - SETT BREAKPOINT OG UNDERSØK ####")
}

angular.bootstrap(rootElement, [hovedmodul.name], {strictDi: true});
/*

console.log('## HDIE');

import { Atmosphere } from 'atmosphere.js';

const atmosphere = new Atmosphere({
    logLevel: 'debug'
});

const subscription = await atmosphere.subscribe(
  {
      url: '/api/ws/modelloppdatert',
      transport: 'websocket',
      fallbackTransport: null,
      reconnect: true,
      reconnectInterval: 2000,
      maxReconnectOnClose: 100
  },
  {
      open: (response) => {
          console.log('## open');
      },
      message: (response) => {
          const data = response.responseBody;
          console.log('## message');

      },
      close: (response) => {
          console.log('## close');
          /!* ... *!/ },
      error: (error) => {
          console.log('## error', error);
          /!* ... *!/ },
      reconnect: (request, response) => {
          console.log('## reconnect');
          /!* ... *!/ },
      transportFailure: (reason, request) => {
          console.log('## transportFailure');
          /!* ... *!/ },
  }
);

//subscription.push(JSON.stringify(msg));

// Or push objects directly (auto-serialized to JSON)
//subscription.push({ author: 'user', message: 'hello' });
*/
